import React from 'react';

import { Balloon } from '@icedesign/base';

export default function ViewBalloon(props) {
  const { trigger, content, align, alignment, ...otherProps } = props;
  return (
    <Balloon
      closable
      alignment={alignment || 'edge'}
      align={align || 'tl'}
      trigger={<span>{trigger}</span>}
      {...otherProps}
    >
      {content}
    </Balloon>
  );
}
